/**
 * Predefined case types for the application
 * Used in case creation forms and filters
 */

export const CASE_TYPES = [
  'Personal Injury',
  'Car Accident',
  'Slip and Fall',
  'Medical Malpractice',
  'Workers Compensation',
  'Wrongful Death',
  'Product Liability',
  'Premises Liability',
  'Dog Bite',
  'Nursing Home Abuse',
  'Birth Injury',
  'Catastrophic Injury',
  'Brain Injury',
  'Spinal Cord Injury',
  'Burn Injury',
  'Other',
] as const;

export type CaseType = typeof CASE_TYPES[number];
